
import CmsHomepageModuleEnum from "@/static/enums/modules/cmsHomepageModuleEnum";
import treatmentsFilter from "@/components/treatmentsFilter.vue";
import treatmentList from "@/components/treatmentList.vue";
import { waitFor } from "vue-wait";
import _ from "lodash-es";

export default {
  head() {
    return {
      title: "Behandlinger",
      titleTemplate: `%s |  ${this.$store.getters["cmsConfigHomepage/getChainName"]}`,
    };
  },
  layout: "HomepageLayout",
  components: {
    treatmentsFilter,
    treatmentList,
  },
  data() {
    return {
      mobileFilter: false,
      tempFilterDepartments: [],
      tempFilterEmployees: [],
    };
  },
  methods: {
    setTempDeptFilter(filter) {
      this.tempFilterDepartments = filter;
    },
    setTempEmpFilter(filter) {
      this.tempFilterEmployees = filter;
    },
    applyFilters() {
      this.$router.push({
        query: {
          ...JSON.parse(JSON.stringify(this.$route.query)),
          department: this.departmentsFromUrl,
          employees: this.employeesFromUrl,
          search: this.searchText != "" ? this.searchText : null,
        },
      });
      this.mobileFilter = false;
    },
    goSearch() {
      waitFor(`loading treatments`, async function () {
        await this.$store.dispatch(
          "treatments/fetchTreatments",
          this.treatmentFilter
        );
        this.$store.commit('treatments/UpdateTreatmentsByCategories', this.treatmentFilter)
      }).apply(this);
    },
    updateCategories(urlSafe) {
      this.categoriesFromUrl = this.categoriesFromUrl.includes(urlSafe) ? this.categoriesFromUrl.filter((x) => x !== urlSafe) : this.categoriesFromUrl.concat([urlSafe])
    }
  },
  async mounted() {
    let cart = this.$store.getters['cart/getCart']
    if (this.departmentsFromUrl.length) {
      if (cart && cart.siteId && cart.siteId !== this.departmentsFromUrl[0] && cart.treatmentIds.length) {
        this.$store.commit('cart/setShowCrossSiteDialog', true)
      } else {
        this.$store.commit("cart/setSelectedSalon", this.departmentsFromUrl[0])
        this.$store.commit('cart/setPreviousSelectedSalon', 0)
      }
    }
    waitFor(`loading treatments`, async function () {
      await this.$store.dispatch("employees/getSiteEmployees", this.$store.getters['cart/getSelectedSalon']);
      await this.$store.dispatch("treatments/fetchTreatments", this.treatmentFilter);
      await this.$store.dispatch("treatments/fetchTreatmentsByCategories")
      this.$store.commit('treatments/UpdateTreatmentsByCategories', this.treatmentFilter)
    }).apply(this);
  },
  computed: {
    categoriesFromUrl: {
      get() {
          const query = JSON.parse(JSON.stringify(this.$route.query));
          return query.category
              ? Array.isArray(query.category)
              ? query.category.map((x) => x)
              : [query.category]
              : [];
      },
      set(value) {
          this.$router.push({
              query: {
              ...JSON.parse(JSON.stringify(this.$route.query)),
              category: value,
              employees: this.employeesFromUrl,
              search: this.searchText,
              },
          });
      },
    },
    searchText: {
      get() {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        return query.search || "";
      },
      set: _.debounce(function (word) {
        this.$router.push({
          query: {
            ...JSON.parse(JSON.stringify(this.$route.query)),
            department: this.departmentsFromUrl,
            employees: this.employeesFromUrl,
            search: word ? word : null,
          },
        });
      }, 1000)
    },
    treatmentFilter() {
      let employees = this.employeesFromUrl.map(x => this.employeeList.find(e => e.base64EmployeeId === x))
      if (employees.length === 1) {
        this.$store.commit('cart/setPreselectedEmployee', employees[0])
      } else {
        this.$store.commit('cart/setPreselectedEmployee', null)
      }
      return {
        searchString: this.searchText ? this.searchText : "",
        siteIds: this.departmentsFromUrl.length ? this.departmentsFromUrl : this.$store.getters['salon/getSiteIds'],
        chainId: this.$store.getters["cmsConfigHomepage/getChainId"],
        categoryIds: [],
        employee: this.employeesFromUrl.map(x => this.employeeList.find(e => e.base64EmployeeId === x).employeeId) || [],
        sortBy: 0,
        sortType: 0,
        page: 1,
        perPage: -1,
      };
    },
    departmentsFromUrl() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.department && !query.department.includes(null) ? Array.isArray(query.department) ? query.department.map((x) => parseInt(x)): [parseInt(query.department)]: [];
    },
    employeesFromUrl() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      return query.employees
        ? Array.isArray(query.employees)
          ? query.employees.map((x) => x)
          : [query.employees]
        : [];
    },
    filteredTreatments() {
      return this.$store.getters["treatments/getTreatments"]
    },
    departmentList() {
      return this.$store.getters["salon/getSalons"].filter(x => x.enabled);
    },
    employeeList() {
      let employees = this.$store.getters["employees/getEmployeesBySiteId"](this.$store.getters['cart/getSelectedSalon'])
      return employees.filter(obj => obj.availableForOnlineBooking)
    },
    primary() {
      return this.$store.getters["cmsConfigHomepage/getPrimary"];
    },
    secondary() {
      return this.$store.getters["cmsConfigHomepage/getSecondary"];
    },
  },
  watch: {
    searchText() {
      this.goSearch();
    },
    employeesFromUrl() {
      waitFor(`refresh treatments`, async function () {
        await this.$store.dispatch(
          "treatments/fetchTreatments",
          this.treatmentFilter
        );
        this.$store.commit('treatments/UpdateTreatmentsByCategories', this.treatmentFilter)
      }).apply(this);
    },
  },
};
